import { Card, Code, CardProps } from "@radix-ui/themes";
import * as DataList from "../data-list.js";
import { RelativeTime } from "./relative-time.js";
import { ListOrganizationApiKeysResponseData } from "../../api/endpoint.js";
import { Translation } from "../i18n/translation.js";

export function ApiKeyDetailsCard({
  apiKey,
  ...cardProps
}: { apiKey: ListOrganizationApiKeysResponseData } & CardProps) {
  return (
    <Card size="2" {...cardProps}>
      <DataList.Root>
        <DataList.Item>
          <DataList.Label>
            <Translation
              defaultMessage="Name"
              id="tuCHkH"
              description="Label for API key name field"
            />
          </DataList.Label>
          <DataList.Value>{apiKey.name}</DataList.Value>
        </DataList.Item>
        <DataList.Item>
          <DataList.Label>
            <Translation
              defaultMessage="Value"
              id="HnuClZ"
              description="Label for API key value field"
            />
          </DataList.Label>
          <DataList.Value>
            <Code color="gray">{apiKey.obfuscatedValue}</Code>
          </DataList.Value>
        </DataList.Item>
        <DataList.Item>
          <DataList.Label>
            <Translation
              defaultMessage="Last used"
              id="elg/zm"
              description="Label for API key last used timestamp"
            />
          </DataList.Label>
          <DataList.Value
            style={apiKey.lastUsedAt ? undefined : { color: "var(--gray-10)" }}
          >
            <RelativeTime
              date={apiKey.lastUsedAt ? new Date(apiKey.lastUsedAt) : undefined}
            />
          </DataList.Value>
        </DataList.Item>
      </DataList.Root>
    </Card>
  );
}
